import { ApiResps } from 'providers';
import { IrCode } from '~/providers/types/irCodes';

export function identifyDutIrCommands(dutIrCmds: ApiResps['/get-dut-ircodes-list']['list']): {
 cmdName: string | null;
 IR_ID: string;
 CMD_TYPE: string;
 CMD_DESC: string;
 TEMPER: number;
}[] {
  return dutIrCmds.map((item) => {
    const desc = (item.CMD_DESC || '').toUpperCase();
    const t1 = (item.TEMPER == null) ? null : String(item.TEMPER);
    const t2 = (desc.match(/(\d+)/g) || []).join(';') || null;
    const T = (t1 === t2) ? t1 : [t1, t2].filter((x) => x).join(';');
    const ehDesl = !!((item.CMD_TYPE === 'AC_OFF') || desc.includes('DESL') || desc.includes('OFF'));
    const ehVent = !!((item.CMD_TYPE === 'AC_FAN') || desc.includes('VENT') || desc.includes('FAN'));
    const ehRefr_pre = !!((item.CMD_TYPE === 'AC_COOL') || desc.includes('COOL') || desc.includes('REFR') || desc.includes('SET') || desc.match(/\bLIG/) || desc.match(/\bON/)) || (item.CMD_DESC && item.CMD_DESC === t2);
    const ehRefr = ehRefr_pre || !!(T && (!ehDesl) && (!ehVent));
    const M = (desc.startsWith('FAKE') ? 'FAKE' : [ehDesl && 'AC_OFF', ehVent && 'AC_FAN', ehRefr && 'AC_COOL'].filter((x) => x).join(';')) || '?';
    let avaliacao = '';
    if ((M === 'AC_OFF') || (M === 'AC_FAN')) { avaliacao = 'OK'; }
    else if ((M === 'AC_COOL') && T && (T.length === 2)) { avaliacao = 'OK'; }
    const identificado = ((avaliacao === 'OK') && `${M}${(M === 'AC_COOL') ? (`:${T}`) : ''}`) || null;
    // identificado = 'AC_OFF' ou 'AC_FAN' ou 'AC_COOL:21' ...
    return { ...item, cmdName: identificado };
  });
}

export function prepareIrCommands(dutIrCmds: ApiResps['/get-dut-ircodes-list']['list']): IrCode[] {
  return identifyDutIrCommands(dutIrCmds)
    .map((command): IrCode | null => {
      if (!command.cmdName) return null;
      const temperStr = command.cmdName.split(':')[1];
      const cmdSetpoint = temperStr === undefined ? null : Number(temperStr);
      if (cmdSetpoint == null || Number.isNaN(cmdSetpoint)) return null;
      return {
        IR_ID: command.IR_ID,
        CMD_NAME: command.cmdName,
        CMD_TYPE: command.CMD_TYPE,
        TEMPER: cmdSetpoint,
      };
    })
    .filter((command): command is IrCode => command !== null)
    .sort((a, b) => (a.CMD_TYPE === b.CMD_TYPE ? a.TEMPER - b.TEMPER : (a.CMD_TYPE === 'AC_COOL' ? -1 : 1)))
    .filter((value, index, self) => index === self.findIndex((t) => (
      t.CMD_NAME === value.CMD_NAME
    )));
}
